import { useCallback, useEffect, useMemo, useState } from 'react';
import { Alert } from '@mui/material';
import ButtonComponent from '../../../../components/common/button/Button';
import TopSection from '../../../LT/TopSection'
import DataDetails from './DataDetails'
import { useDispatch, useSelector } from 'react-redux';
import { postNewContractData } from '../../../../redux/actions/ContractMaintenance/NewContract';
import { postNewContractDataEndpoint, postSaveContractEndpoint, postSubmitContractMaintenanceEndpoint, putDeleteContractEndpoint } from '../../../../common/endpoints';
import { Loader } from '../../../../components/common/Loader';
import { toast } from 'react-toastify';
import { postSaveContractData } from '../../../../redux/actions/ContractMaintenance/SaveContracts';
import { putDeleteContractData } from '../../../../redux/actions/ContractMaintenance/DeleteContracts';
import { postSubmitContractMaintenance } from '../../../../redux/actions/ContractMaintenance/SubmitContractMaintenance';
import { setSelectedItem } from '../../../../redux/actions/SupportTicket/selectionSlice';

const NewContract = () => {
  const dispatch = useDispatch();
  const [rowsData, setRowsData] = useState([]);
  const [btnDisabled, setIsBtnDisabled] = useState(true);
  const [isDeleteBtnDisable, setIsDeleteBtnDisable] = useState(true);
  const [seqIds, setSeqIds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [getAllMaintenanceData, setGetAllMaintenanceData] = useState([]);
  const [isSubmitForecastDisabled, setIsSubmitForecastDisabled] = useState(false);

  const userEmail = localStorage.getItem("data");
  const userName = localStorage.getItem("userName");
  const userRole = localStorage.getItem("CDRole");

  const cleanUsername = (name) => {
    return name.replace(/\s*\[C\]/, ""); // Removes "[C]" with optional leading space
  };

  const postNewContractMaintenanceData = useSelector((state) => state?.postNewContractDataSlice?.data);

  const pagination = true;
  const paginationPageSize = Number(localStorage.getItem("cmPageSize")) || 50;
  const paginationPageSizeSelector = [50, 100, 200, 500, 2000];

  const handleCellValueChange = (params) => {
      if (rowsData.some(row => row.uniqueRowId === params.data.uniqueRowId)) {
        const updatedSelectedRows = rowsData.map(row =>
          row.uniqueRowId === params.data.uniqueRowId ? params.data : row
        );
        setRowsData(updatedSelectedRows);
      }
    }

    const onSelectionChanged = (params) => {
      const selectedRowsOnCurrentPage = [];
      const currentPage = params.api.paginationGetCurrentPage();
      const pageSize = params.api.paginationGetPageSize();
      let index = 0;

      params.api.forEachNodeAfterFilterAndSort((node) => {
        const nodePage = Math.floor(index / pageSize);
        if (nodePage === currentPage && node.isSelected()) {
          selectedRowsOnCurrentPage.push(node.data);
        }
        index++;
      });

      setRowsData(selectedRowsOnCurrentPage);
      dispatch(setSelectedItem(selectedRowsOnCurrentPage));

      const ids = selectedRowsOnCurrentPage?.map(item => item?.contractSeqId);
      setSeqIds(ids);

      const hasInvalidSeqId = selectedRowsOnCurrentPage.some((row) => !row.contractSeqId || row.contractSeqId === ""); 
      setIsDeleteBtnDisable(selectedRowsOnCurrentPage.length === 0 || hasInvalidSeqId);
      setIsBtnDisabled(selectedRowsOnCurrentPage.length === 0);

      // disable submit if any selected row has forecast blank/zero (only affects Submit button)
      // const hasInvalidForecastFlag = selectedRowsOnCurrentPage.some((row) => {
      //   const fv = row?.forecast;
      //   if (fv === null || fv === undefined) return true;
      //   const s = String(fv).trim();
      //   if (s === "") return true;
      //   // treat "0", "0.0", "0.000" as zero
      //   const n = parseFloat(s.replace(/,/g, ""));
      //   return !isNaN(n) && n === 0;
      // });

      // if (hasInvalidForecastFlag) {
      //   toast.warn('Submit Button will be disabled for the selection with Line items having 0/Blank Forecast.', {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     progress: undefined,
      //     theme: "light",
      //   });
      // }

      // setIsSubmitForecastDisabled(hasInvalidForecastFlag);
    };

  
  const rowSelection = useMemo(() => {
    return {
      mode: "multiRow",
      isRowSelectable: (rowNode) =>
        rowNode.data && userRole !== "Viewer"
          ? true
          : false,
    };
  }, [userRole]);

  const saveContractsMaintenanceHandler = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        postSaveContractData({
          dynamicEndpoint: `${postSaveContractEndpoint}?userId=${userEmail}&userName=${cleanUsername(userName)}&cmType=NEW`,
          data: rowsData
        })
      );
      if (response.meta.requestStatus === "fulfilled") {
        await callSameFilterApi();
        toast.success(response.payload.cmSaveDTO.message, {
          autoClose: 2000,
        });
        setIsBtnDisabled(true);
        setIsDeleteBtnDisable(true);
      } else {
        setIsLoading(false);
        toast.error(response.payload.errorMessage, {
          autoClose: 2000,
        });
        setIsBtnDisabled(true);
        setIsDeleteBtnDisable(true);
      }
    } catch (error) {
      console.error("Error saving contracts maintenance data:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const deleteContractMaintenanceHandler = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        putDeleteContractData({
          dynamicEndpoint: `${putDeleteContractEndpoint}?userId=${userEmail}&userName=${cleanUsername(userName)}`,
          data: {
            contractSeqIds: seqIds,
          }
        })
      );
      if (response.meta.requestStatus === "fulfilled") {
        await callSameFilterApi();
        toast.success(`Contract Line item change Deleted`, {
          autoClose: 2000,
        });
        setIsBtnDisabled(true);
        setIsDeleteBtnDisable(true);
      }
    } catch (error) {
      console.error("Error saving contracts maintenance data:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleContractSubmit = async () => {
    setIsLoading(true);
      try {
        const response = await dispatch(
          postSubmitContractMaintenance({
            dynamicEndpoint: `${postSubmitContractMaintenanceEndpoint}?userName=${cleanUsername(userName)}&cmType=NEW&userEmailList=${userEmail}`,
            data: rowsData
          })
        );
        if (response.meta.requestStatus === "fulfilled") {
          await callSameFilterApi();
          toast.success(response.payload, {
            autoClose: 2000,
          });
          setIsBtnDisabled(true);
        } else {
          setIsLoading(false)
          toast.error(response.payload.errorMessage, {
            autoClose: 2000,
          });
          setIsBtnDisabled(true)
          setIsDeleteBtnDisable(true)
        }
      } catch (error) {
        console.error("Error saving contracts maintenance data:", error);
      } finally {
        setIsLoading(false);
      }
  }

  const callSameFilterApi = useCallback(async () => {
    setIsLoading(true);
    const stored = localStorage.getItem("contractMaintenancePostFilterData");
    if (stored) {
      const filterData = JSON.parse(stored);
      try {
        const response = await dispatch(
          postNewContractData({
            dynamicEndpoint: `${postNewContractDataEndpoint}?userId=${userEmail}&userName=${cleanUsername(userName)}`,
            data: {
              ...filterData,
            }
          })
        );
        if (response.meta.requestStatus === "fulfilled") {
          setGetAllMaintenanceData(response.payload);
        }
      } finally {
        setIsLoading(false);
      }
    }
  }, [dispatch, userEmail, userName]);

  useEffect(() => {
    callSameFilterApi();
  }, [callSameFilterApi]);

  return (
    <>
        <TopSection
            labelList={[
            { title: "Home", path: "/landing-page" },
            { title: "Contract Maintenance", path: "/contract-maintenance" },
            { title: "New Contract" },
            ]}
            hideHeader={true}
            headerName={"New Contract"}
        />
        <div className="priceMemo_dataTable">
          {isLoading ? (
            <Loader />
          )
          :
          <>
            {/* <Alert
              severity="info"
              sx={{
                padding: "2px 16px !important",
                marginTop: "5px",
                marginBottom: "10px",
                fontWeight: "bold",
                fontSize: "15px !important",
              }}
            >
              Submit Button will be disabled for the selection with Line items having 0/Blank Forecast.
            </Alert> */}
            <DataDetails 
              rowData={postNewContractMaintenanceData?.cmMaintenanceView || getAllMaintenanceData}
              pagination={pagination}
              paginationPageSize={paginationPageSize}
              paginationPageSizeSelector={paginationPageSizeSelector}
              onSelectionChanged={onSelectionChanged}
              rowSelection={rowSelection}
              handleCellValueChange={handleCellValueChange}
              userRole={userRole}
            />
            </>
          }
          {userRole !== "Viewer" &&
            <div
              style={{
                marginTop: "50px",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "30px",
              }}
            >
              <div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "250px",
                }}
              >
                <ButtonComponent
                  label="Delete"
                  bgColor="#fff"
                  color="#000"
                  disabled={isDeleteBtnDisable}
                  onClick={deleteContractMaintenanceHandler}
                />
                <ButtonComponent
                  label="Save"
                  bgColor="#fff"
                  color="#000"
                  disabled={btnDisabled}
                  onClick={saveContractsMaintenanceHandler}
                />
                <ButtonComponent
                  label="Submit"
                  bgColor="#000"
                  color="#fff"
                  onClick={handleContractSubmit}
                  disabled={btnDisabled}
                 // disabled={btnDisabled || isSubmitForecastDisabled}
                />
              </div>
            </div>
          }
          </div>
        
    </>
  )
}

export default NewContract